/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-01-05T10:42:26.802
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getFinancialElectronicAccountFreezeEditInit,
	getFinancialElectronicAccountFreezeView
} from '@api/financial/FinancialElectronicAccountFreeze';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getFinancialElectronicAccountFreezeEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialElectronicAccountFreezeEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialElectronicAccountFreezeView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialElectronicAccountFreezeView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
